import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.revisionStatus;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const revisionStatusSelector = createSelector(
    selectFeature, 
    (state) => state.revisionStatus
);

export const notFinalRevisionStatusSelector = createSelector(
    selectFeature, 
    (state) => state.notFinalRevisionStatus
);